__turbopack_context__.v({
  "actions": "AppsPage-module__I9BB7a__actions",
  "appCard": "AppsPage-module__I9BB7a__appCard",
  "appLogo": "AppsPage-module__I9BB7a__appLogo",
  "cardFooter": "AppsPage-module__I9BB7a__cardFooter",
  "cardHeader": "AppsPage-module__I9BB7a__cardHeader",
  "cardTitle": "AppsPage-module__I9BB7a__cardTitle",
  "category": "AppsPage-module__I9BB7a__category",
  "description": "AppsPage-module__I9BB7a__description",
  "emptyState": "AppsPage-module__I9BB7a__emptyState",
  "error": "AppsPage-module__I9BB7a__error",
  "grid": "AppsPage-module__I9BB7a__grid",
  "headerActions": "AppsPage-module__I9BB7a__headerActions",
  "headerButton": "AppsPage-module__I9BB7a__headerButton",
  "iconButton": "AppsPage-module__I9BB7a__iconButton",
  "loading": "AppsPage-module__I9BB7a__loading",
  "moreInfo": "AppsPage-module__I9BB7a__moreInfo",
  "pageHeader": "AppsPage-module__I9BB7a__pageHeader",
  "pageTitle": "AppsPage-module__I9BB7a__pageTitle",
  "searchContainer": "AppsPage-module__I9BB7a__searchContainer",
  "searchIcon": "AppsPage-module__I9BB7a__searchIcon",
  "searchInput": "AppsPage-module__I9BB7a__searchInput",
  "searchWrapper": "AppsPage-module__I9BB7a__searchWrapper",
  "skeleton": "AppsPage-module__I9BB7a__skeleton",
  "skeletonCard": "AppsPage-module__I9BB7a__skeletonCard",
  "skeletonCardHeader": "AppsPage-module__I9BB7a__skeletonCardHeader",
  "skeletonFooter": "AppsPage-module__I9BB7a__skeletonFooter",
  "skeletonLogo": "AppsPage-module__I9BB7a__skeletonLogo",
  "skeletonShimmer": "AppsPage-module__I9BB7a__skeletonShimmer",
  "tab": "AppsPage-module__I9BB7a__tab",
  "tabActive": "AppsPage-module__I9BB7a__tabActive",
  "tabs": "AppsPage-module__I9BB7a__tabs",
  "tabsContainer": "AppsPage-module__I9BB7a__tabsContainer",
});
